export default class E2ESmartfieldController {
	/* @ngInject */
	constructor() {
		/** @type {?(import('angular').IFormController)} */
		this.form = null;

		// classic
		this.sm1 = {
			model: {},
			disabled: false,
			required: true,
			qrcode: false,
			order: 'K_NODE;FIRSTNAME',
			placeholder: 'SM 1',
		};

		// qr code, disabled
		this.sm2 = {
			model: {},
			disabled: true,
			required: true,
			qrcode: true,
			order: 'K_NODE;FIRSTNAME',
			placeholder: 'SM 2',
		};

		this.sm3 = {
			model: {},
			disabled: false,
			required: true,
			qrcode: false,
			order: 'K_NODE;FIRSTNAME',
			placeholder: 'SM 3',
			validate: {
				pattern: '^[0-9]{4}$',
			},
		};

		this.sm4 = {
			model: {},
			disabled: false,
			required: true,
			qrcode: false,
			order: 'K_NODE;FIRSTNAME',
			placeholder: 'SM 4',
			validate: {
				minLength: 3,
				maxLength: 5,
			},
		};

		this.$onInit();
	}

	$doCheck() {}

	$onInit() {}
}
